import { cloneDeep, isEmpty } from 'lodash';
import {
  getRecommendationKeys,
  getStaffPickAppKeys,
  getStaffPickCategories,
  getStaffPicksMsg
} from './helpers';

import { buildIntentMessages, handleCategory } from './filterPSDataHelper';

const buildTree = psData => {
  const deepCopy = cloneDeep(psData);
  const {
    tools = [],
    sections = [],
    main = [],
    staffPickMsg = [],
    defaultRecommended = [],
    isLoggedIn,
    intentMessages = [],
    isStaffPickEligible,
    isNewLayoutEligible
  } = deepCopy;
  let { categories = [] } = deepCopy;
  const staffPickDisplayed = getStaffPicksMsg(
    staffPickMsg,
    defaultRecommended,
    isLoggedIn,
    tools,
    isNewLayoutEligible
  );
  const staffPickAppKeys = getStaffPickAppKeys(staffPickDisplayed);
  const staffPickCategory = getStaffPickCategories(staffPickAppKeys, tools);
  const [mainContent = {}] = main;
  const recommendations = getRecommendationKeys(defaultRecommended);
  categories = categories.map(c =>
    handleCategory(c, sections, tools, recommendations, {
      isLoggedIn,
      staffPickCategory,
      staffPickAppKeys,
      intentMessages,
      isStaffPickEligible,
      isNewLayoutEligible
    })
  );
  return {
    content: mainContent,
    categories,
    staffPickDisplayed,
    intentToolsDisplayed: intentMessages
  };
};

export default ({
  psData = {},
  mtsData = {},
  isLoggedIn = false,
  experimentation,
  productIntentTools = [],
  merchantActivationState,
  collectionIntentBanners,
  twofersIntelligentApps
}) => {
  let { tools = [], categories = [], sections = [] } = psData;
  const { recommended = [] } = psData;
  const { staffPickExp, v2LayoutExp, searchModalExp } = experimentation;
  // filter the tools	if `mtsData` is not empty
  if (!isEmpty(mtsData)) {
    tools = tools.filter(({ appKey = '' }) => mtsData[appKey]);
  }
  const isStaffPickEligible = staffPickExp;
  const isNewLayoutEligible = v2LayoutExp;
  const isSearchModalEligible = searchModalExp;
  const isRecommendedCategoryEligible = recommended && recommended.length > 0;
  const isIntentEligible = productIntentTools && productIntentTools.length > 0;
  const isGetStartedEligible =
    !merchantActivationState && isLoggedIn && psData.getStartedMsg;
  const appLimit = isSearchModalEligible ? 7 : 4;
  const defaultRecommended = isRecommendedCategoryEligible
    ? tools.slice(0, appLimit)
    : [];
  const { getStartedMsg = [] } = psData;
  const intentMessages = buildIntentMessages(
    tools,
    productIntentTools,
    getStartedMsg,
    { isIntentEligible, isLoggedIn, isGetStartedEligible, isNewLayoutEligible }
  );

  // ...then go back and filter out any sections that no longer have tools
  // sectionKey is defaulted to random string to filter out sections with
  // no content
  sections = sections.filter(({ sectionKey: sk = 'heisenberg' }) => {
    return tools.some(({ sectionKey = '' }) => sectionKey === sk);
  });

  // ...then go back and filter out any categories that no longer have tools
  // ditto as above for random default string for categoryKey
  categories = categories.filter(({ categoryKey: cK = 'schrodinger' }) => {
    return tools.some(({ categoryKey = '' }) => categoryKey === cK);
  });
  const args = {
    ...psData,
    tools,
    categories,
    sections,
    defaultRecommended,
    isLoggedIn,
    intentMessages,
    isStaffPickEligible,
    isNewLayoutEligible
  };

  const structuredData = buildTree(args);

  tools = tools.reduce((acc, tool) => {
    acc[tool.appKey] = tool;
    return acc;
  }, {});

  sections = sections.reduce((acc, section) => {
    acc[section.sectionKey] = section;
    return acc;
  }, {});

  categories = categories.reduce((acc, category) => {
    acc[category.categoryKey] = category;
    return acc;
  }, {});

  const flatData = {
    ...psData,
    tools,
    categories,
    sections,
    defaultRecommended,
    isRecommendedCategoryEligible,
    intentMessages,
    isMerchantActivated: merchantActivationState,
    isNewLayoutEligible,
    collectionIntentBanners,
    twofersIntelligentApps
  };

  return {
    flatData,
    structuredData
  };
};
